import { IconButton } from "@fluentui/react";
import { IExtendedColumn, ScheduleJEResponseFromAPI } from "@jem/components";
import React from "react";

interface IScheduleDetailsColumn extends IExtendedColumn {
  fieldName: keyof ScheduleJEResponseFromAPI;
}

interface IScheduleDetailsColumnsProps {
  onViewClick: (item: ScheduleJEResponseFromAPI) => void;
  onEditClick: (item: ScheduleJEResponseFromAPI) => void;
  onTerminateClick: (item: ScheduleJEResponseFromAPI) => void;
  onAuditClick: (item: ScheduleJEResponseFromAPI) => void;
  currentTile: string;
}

export const getScheduleDetailsColumns =
  ({ onViewClick, onEditClick, onTerminateClick, onAuditClick, currentTile }: IScheduleDetailsColumnsProps) =>
  (): IScheduleDetailsColumn[] => {
    const cols: IScheduleDetailsColumn[] = [
      {
        key: "recurringScheduleName",
        name: "Recurring schedule name",
        fieldName: "recurringScheduleName",
        type: "string",
        minWidth: 130
      },
      {
        key: "Actions",
        name: "Actions",
        fieldName: "recurringScheduleName",
        type: "string",
        minWidth: 120,
        onRender: (item: ScheduleJEResponseFromAPI): JSX.Element | React.ReactText | null => {
          return (
            <>
              <IconButton
                iconProps={{ iconName: "View" }}
                title="View"
                ariaLabel="View Schedule"
                styles={{
                  root: {
                    padding: 0
                  }
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onViewClick(item);
                }}
              />
              <IconButton
                iconProps={{ iconName: "Edit" }}
                title="Edit"
                ariaLabel="Edit Schedule"
                styles={{
                  root: {
                    padding: 0
                  }
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onEditClick(item);
                }}
              />
              <IconButton
                iconProps={{ iconName: "Delete" }}
                title="Terminate"
                ariaLabel="Terminate Schedule"
                styles={{
                  root: {
                    padding: 0
                  }
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onTerminateClick(item);
                }}
              />
              <IconButton
                iconProps={{ iconName: "People" }}
                title="Audit"
                ariaLabel="Audit"
                styles={{
                  root: {
                    padding: 0
                  }
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onAuditClick(item);
                }}
              />
            </>
          );
        }
      },
      {
        key: "frequency",
        name: "Frequency",
        fieldName: "recurringFrequency",
        type: "string",
        minWidth: 100
      },
      {
        key: "isLocalCurrency",
        name: "Local Currency",
        fieldName: "isLocalCurrency",
        type: "string",
        minWidth: 100,
        onRender: (item) => (item.isLocalCurrency ? "True" : "False")
      },
      {
        key: "noOfJEPosted",
        name: "No. of JE's Posted",
        fieldName: "noOfJEPosted",
        type: "number",
        minWidth: 80
      },
      {
        key: "postingsRemaining",
        name: "Postings Remaining",
        fieldName: "postingsRemaining",
        type: "number",
        minWidth: 130
      },
      {
        key: "nextPostingDate",
        name: "Next Posting Date",
        fieldName: "nextPostingDate",
        type: "string",
        minWidth: 130
      },
      {
        key: "poster",
        name: "Assigned Poster",
        fieldName: "poster",
        type: "string",
        minWidth: 130
      },
      {
        key: "reviewer",
        name: "Assigned Reviewer",
        fieldName: "reviewer",
        type: "string",
        minWidth: 130
      },
      {
        key: "preReviewer",
        name: "Pre-Reviewer",
        fieldName: "preReviewer",
        type: "string",
        minWidth: 130
      },
      {
        key: "additionalPosters",
        name: "Additional Posters",
        fieldName: "additionalPosters",
        type: "string",
        minWidth: 130
      },
      {
        key: "recurringScheduleStatus",
        name: "Status",
        fieldName: "recurringScheduleStatus",
        type: "string",
        minWidth: 100
      },
      {
        key: "scheduleStartDate",
        name: "Schedule Start Date",
        fieldName: "scheduleStartDate",
        type: "string",
        minWidth: 130
      },
      {
        key: "scheduleEndDate",
        name: "Schedule End Date",
        fieldName: "scheduleEndDate",
        type: "string",
        minWidth: 130
      }
    ];

    if (currentTile === "all") {
      cols.push({
        key: "comments",
        name: "Comments",
        fieldName: "comments",
        type: "string",
        minWidth: 130
      });
    } else {
      cols.push({
        key: "terminationComments",
        name: "Termination Comments",
        fieldName: "terminationComments",
        type: "string",
        minWidth: 130
      });
    }

    cols.push(
      {
        key: "companyCode",
        name: "Company Code",
        fieldName: "companyCode",
        type: "string",
        minWidth: 130
      },
      {
        key: "opsDetails",
        name: "Ops Details",
        fieldName: "opsDetails",
        type: "string",
        minWidth: 130
      }
    );

    cols.push(
      {
        key: "recurringScheduleGUID",
        name: "Recurring Schedule GUID",
        fieldName: "recurringScheduleGUID",
        type: "string",
        minWidth: 130
      },
      {
        key: "LastModifiedDate",
        name: "Last Modified Date",
        fieldName: "lastModifiedDate",
        type: "string",
        minWidth: 130
      }
    );
    return cols;
  };
